import apiService, { APIResponse } from "./axios";

import { store } from "../../store/store"; // Pfad zu deinem Store-File
import { setVehicles } from "../../store/orm/vehicles";

class ORMVehiclesService {
  async fetchVehicles() {
    const response: APIResponse<any> =
      await apiService.get<any>("api/rent/groups");

    if (response.error) {
      console.error("Fehler:", response.message);
      return;
    }

    store.dispatch(setVehicles(response as any));
  }
}

const ormVehiclesService = new ORMVehiclesService();
export default ormVehiclesService;
